export const MIN_PRICE = 0.05;
export const MAX_PRICE = 250;
